import React, { useEffect } from 'react';
import ReactECharts from 'echarts-for-react';
import moment from 'moment';

const TokenVolumeGraph = ({ data, t }) => {
  // 1. Preparar los datos para el gráfico
  const days = [];
  const usageValues = [];

  useEffect(() => {
    moment.locale(t.language === 'en' ? 'en' : 'es');
  }, [t.language])
  
  for (let day = 1; day <= data.daysInMonth; day++) {
    days.push(day);
    usageValues.push(data.dailyUsage[day] || 0);
  }

  // 2. Configuración del gráfico
  const option = {
    title: {
      left: 'center',
      textStyle: {
        fontSize: 16,
        fontWeight: 'bold'
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
      formatter: function(params) {
        return `${params[0].name}: ${params[0].value} ${t('conversations')}`;
      }
    },
    xAxis: {
      type: 'category',
      name: t('xAxis'),
      data: days,
      axisLabel: {
        interval: 0, // Mostrar todos los días
        rotate: 0, // Rotar etiquetas si hay muchos días
        fontSize: 10
      },
      axisLine: {
        lineStyle: {
          color: '#333'
        }
      }
    },
    yAxis: {
      type: 'value',
      name: t('yAxis'),
      axisLine: {
        show: true
      },
      splitLine: {
        lineStyle: {
          type: 'dashed'
        }
      }
    },
    series: [{
      name: 'Tokens',
      type: 'bar',
      data: usageValues,
      itemStyle: { color: "#00a4e0" },
      barWidth: '70%',
      label: {
        show: true,
        position: 'top',
        formatter: function(params) {
          return params.value > 0 ? params.value : '';
        },
        fontSize: 12,
        color: '#333'
      },
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }],
    grid: {
      top: 36,
      right: 4,
      bottom: 24,
      left: '5%',
      contaionLabel: true
    }
  };

  return (
    <div style={{ width: '100%', height: '310px' }}>
      <ReactECharts 
        option={option} 
        style={{ height: '100%', width: '100%' }} 
        className="token-usage-chart"
      />
    </div>
  );
}

export default TokenVolumeGraph;